export var ExpenseBoolean;
(function (ExpenseBoolean) {
    ExpenseBoolean["TRUE"] = "true";
    ExpenseBoolean["FALSE"] = "false";
})(ExpenseBoolean || (ExpenseBoolean = {}));
